// export const UCC_ID = [11, 3];
// // export const FilmType = ['Film_Type','Nature_of_Source','Picture_Reference_/_FPS','Audio']
// export const FilmType = [77, 70, 41, 71];
// export const SourceDeliverable = [13, 74, 75, 12, 76, 77];

export const UCC_ID = ['UCCID', 'Film_Title'];
export const FilmType = [
  'Film Element',
  'Picture Reference/FPS',
  'Film Type',
  'Audio',
];
export const SourceDeliverable = [
  'Total Reels',
  'Audio Type',
  'FPS',
  'Bit Depth',
  'Sample Rate',
  'Audio Format',
];

export const AVSyncValidation = [
  ...UCC_ID,
  ...FilmType,
  ...SourceDeliverable,
]
export const label = {
  'Film Element': 'Film Type',
  'Film Type': 'Film Type (BW/Color)',
  'Total Reels': 'No. of Reels',
  'AVSync Overall Remark': 'Overall Remark',
  Film_Title: 'Title Name',
};
